{
  "error-handler-service": {
    "backend-message": {
      "customer": {
        "blackListed": "Možnost online rezervace v tomto salonu je zablokována. Pro rezervaci nové schůzky kontaktujte salon",
        "existed": "Účet již existuje",
        "notFound": "Účet nelze nalézt",
        "credentialNotMatched": "Kód PIN je neplatný. Zkuste to prosím znovu!",
        "numberOfCredentialFailedMatchesAlreadyExceedMax": "Počet opakovaných pokusů je překročen. Pro další podporu se obraťte na studio",
        "customerNumberOfCredentialResendExceedMax": "Počet opakovaných pokusů je překročen. Pro další podporu se obraťte na studio",
        "waitingPeriodBeforeResendNotOverYet": "Buďte prosím trpěliví, dokud nebudete moci přibližně po jedné minutě znovu odeslat kód PIN."
      },
      "businessObject": {
        "alreadyCheckedIn": "Už jsem se přihlásil. Zkuste to prosím po několika minutách znovu.",
        "notFound": "Studio nelze nalézt"
      },
      "credit-package-order": {
        "no-capture-payments": "Objednávka kreditního balíčku se nezdařila",
        "order-already-fulfilled": "Objednávka kreditního balíčku již byla vyřízena",
        "order-already-rejected": "Objednávka kreditního balíčku byla zamítnuta"
      },
      "email": {
        "exists-confirmed-and-not-changeable": "Jednou potvrzený e-mail již nelze změnit!"
      },
      "error": {
        "email-exists": "Z bezpečnostních důvodů přijímáme jedinečný e-mail spojený s jedinečným telefonním číslem. Vaše telefonní číslo je přiřazeno k již používanému e-mailu. Zkuste se prosím přihlásit pomocí svého e-mailu.",
        "invalid-code": "Kód PIN je neplatný. Zkuste to prosím znovu!",
        "phoneNr-exists": "Z bezpečnostních důvodů přijímáme jedinečný e-mail spojený s jedinečným telefonním číslem. Váš e-mail je spojen s již používaným telefonním číslem. Zkuste se prosím přihlásit pomocí svého telefonního čísla."
      },
      "review": {
        "notFound": "Neplatná nebo neplatná adresa URL"
      },
      "startTime": {
        "invalid": "Vybraný časový interval již není k dispozici. Vyberte si prosím jiný časový slot!"
      },
      "Unauthorized": "Přihlaste se znovu pomocí správného e-mailu a hesla!",
      "user-challenge": {
        "too-much-requests": "Často jste si vyžádali. Zkuste to prosím po několika sekundách znovu"
      },
      "appointment duration is too long, max 4 hours": "Maximální doba trvání je 4 hodiny. Změňte prosím vybrané služby.",
      "No available slot at desired start time": "Vybraný časový interval již není k dispozici. Vyberte si prosím jiný časový slot!",
      "confirmed appointment already exists at same time": "Již jste si rezervovali schůzku na stejný čas",
      "customer already has maximum number of confirmed appointments": "Maximální počet schůzek v tomto salonu byl vyčerpán. Pro rezervaci nové schůzky kontaktujte salon"
    },
    "text": {
      "server-connection-error": "Žádné připojení k serveru",
      "general-error": "Ups! Něco se pokazilo. Zkuste to prosím později."
    }
  }
}
